import occhio1 from "./images/occhio1.jpg"
import occhio2 from "./images/occhio2.jpg"
import occhio3 from "./images/occhio3.jpg"
import occhio4 from "./images/occhio4.jpg"
import occhio5 from "./images/occhio5.jpg"
import occhio6 from "./images/occhio6.jpg"

import rio1 from "./images/rio1.jpg"
import rio2 from "./images/rio2.jpg"
import rio3 from "./images/rio3.jpg"
import rio4 from "./images/rio4.jpg"
import rio5 from "./images/rio5.jpg"
import rio6 from "./images/rio6.jpg"
import rio7 from "./images/rio7.jpg"
import etere1 from "./images/4_elementi.JPG"
import etere2 from "./images/etere2.jpg"
import etere3 from "./images/etere3.jpg"
import etere4 from "./images/etere4.jpg"
import etere5 from "./images/etere5.jpg"
import etere6 from "./images/etere6.jpg"
import etere7 from "./images/etere7.jpg"
import granada1 from "./images/granadajpg/granada (2).jpg"
import granada2 from "./images/granadajpg/granada (1).jpg"
import granada3 from "./images/granadajpg/granada (3).jpg"
import granada4 from "./images/granadajpg/granada (4).jpg"
import granada5 from "./images/granadajpg/granada (5).jpg"
import granada6 from "./images/granadajpg/granada (6).jpg"
import granada7 from "./images/granadajpg/granada (7).jpg"
import babele1 from "./images/babeleverdejpg/babele1.jpg"
import babele2 from "./images/babeleverdejpg/babele2.jpg"
import babele3 from "./images/babeleverdejpg/babele3.jpg"
import babele4 from "./images/babeleverdejpg/babele4.jpg"
import babele5 from "./images/babeleverdejpg/babele5.jpg"
import babele6 from "./images/babeleverdejpg/babele6.jpg"
import babele7 from "./images/babeleverdejpg/babele7.jpg"

import altrove1 from "./images/altrovejpg/altrove.jpg"
import altrove2 from "./images/altrovejpg/altrove (1).jpg"
import altrove3 from "./images/altrovejpg/altrove (2).jpg"
import altrove4 from "./images/altrovejpg/altrove (3).jpg"
import altrove5 from "./images/altrovejpg/altrove (4).jpg"
import altrove6 from "./images/altrovejpg/altrove (5).jpg"
import altrove7 from "./images/altrovejpg/altrove (6).jpg"
import altrove8 from "./images/altrovejpg/altrove (7).jpg"
import altrove9 from "./images/altrovejpg/altrove (8).jpg"
import altrove10 from "./images/altrovejpg/altrove (9).jpg"
import abisso1 from "./images/abissoblujpg/abissoblu (3).jpg"
import abisso2 from "./images/abissoblujpg/abissoblu (1).jpg"
import abisso3 from "./images/abissoblujpg/abissoblu (2).jpg"
import abisso4 from "./images/abissoblujpg/abissoblu (4).jpg"
import abisso5 from "./images/abissoblujpg/abissoblu (5).jpg"
import abisso6 from "./images/abissoblujpg/abissoblu (6).jpg"
import abisso7 from "./images/abissoblujpg/abissoblu (7).jpg"

import pianoQuin1 from "./images/pianoQuin/pianoQuin (1).jpg"
import pianoQuin2 from "./images/pianoQuin/pianoQuin (2).jpg"
import pianoQuin3 from "./images/pianoQuin/pianoQuin (3).jpg"
import pianoQuin4 from "./images/pianoQuin/pianoQuin (4).jpg"
import pianoQuin5 from "./images/pianoQuin/pianoQuin (5).jpg"
import pianoQuin6 from "./images/pianoQuin/pianoQuin (6).jpg"
import pianoQuin7 from "./images/pianoQuin/pianoQuin (7).jpg"

import alba1 from "./images/albajpg/alba (1).jpg"
import alba2 from "./images/albajpg/alba (2).jpg"
import alba3 from "./images/albajpg/alba (3).jpg"
import alba4 from "./images/albajpg/alba (4).jpg"
import alba5 from "./images/albajpg/alba (5).jpg"
import alba6 from "./images/albajpg/alba (6).jpg"
import alba7 from "./images/albajpg/alba (7).jpg"
import ctrl7 from "./images/CTRL/CTRL (1).jpg";
import ctrl2 from "./images/CTRL/CTRL (2).jpg";
import ctrl3 from "./images/CTRL/CTRL (3).jpg";
import ctrl4 from "./images/CTRL/CTRL (4).jpg";
import ctrl5 from "./images/CTRL/CTRL (5).jpg";
import ctrl6 from "./images/CTRL/CTRL (6).jpg";
import ctrl1 from "./images/CTRL/CTRL (7).jpg";

import rosa1 from "./images/marearosaJPG/rosa (1).jpg";
import rosa2 from "./images/marearosaJPG/rosa (2).jpg";
import rosa3 from "./images/marearosaJPG/rosa (3).jpg";
import rosa4 from "./images/marearosaJPG/rosa (4).jpg";
import rosa5 from "./images/marearosaJPG/rosa (5).jpg";
import rosa6 from "./images/marearosaJPG/rosa (6).jpg";


import naturaViva1 from "./images/naturaVivaJPG/naturaViva (1).jpg";
import naturaViva2 from "./images/naturaVivaJPG/naturaViva (2).jpg";
import naturaViva3 from "./images/naturaVivaJPG/naturaViva (3).jpg";
import naturaViva4 from "./images/naturaVivaJPG/naturaViva (4).jpg";
import naturaViva5 from "./images/naturaVivaJPG/naturaViva (5).jpg";
import naturaViva6 from "./images/naturaVivaJPG/naturaViva (6).jpg";
import naturaViva7 from "./images/naturaVivaJPG/naturaViva (7).jpg";


import nevermind1 from "./images/nevermindJPG/nevermind (1).jpg";
import nevermind2 from "./images/nevermindJPG/nevermind (2).jpg";
import nevermind3 from "./images/nevermindJPG/nevermind (3).jpg";
import nevermind4 from "./images/nevermindJPG/nevermind (4).jpg";
import nevermind5 from "./images/nevermindJPG/nevermind (5).jpg";
import nevermind6 from "./images/nevermindJPG/nevermind (6).jpg";
import nevermind7 from "./images/nevermindJPG/nevermind (7).jpg";

import pinkfloyd1 from "./images/pinkfloyjpg/pinkfloyd (1).jpg"
import pinkfloyd2 from "./images/pinkfloyjpg/pinkfloyd (2).jpg"
import pinkfloyd3 from "./images/pinkfloyjpg/pinkfloyd (3).jpg"
import pinkfloyd4 from "./images/pinkfloyjpg/pinkfloyd (4).jpg"
import pinkfloyd5 from "./images/pinkfloyjpg/pinkfloyd (5).jpg"
import pinkfloyd6 from "./images/pinkfloyjpg/pinkfloyd (6).jpg"
import pinkfloyd7 from "./images/pinkfloyjpg/pinkfloyd (7).jpg"
import splendere1 from "./images/splendereAlTramonto/splendere (5).jpg";
import splendere2 from "./images/splendereAlTramonto/splendere (1).jpg";
import splendere3 from "./images/splendereAlTramonto/splendere (2).jpg";
import splendere4 from "./images/splendereAlTramonto/splendere (3).jpg";
import splendere5 from "./images/splendereAlTramonto/splendere (4).jpg";
import splendere6 from "./images/splendereAlTramonto/splendere (6).jpg";
import splendere7 from "./images/splendereAlTramonto/splendere (7).jpg";

import elena1 from "./images/elena_JPG/elena (1).jpg";
import elena2 from "./images/elena_JPG/elena (2).jpg";
import elena3 from "./images/elena_JPG/elena (3).jpg";
import elena4 from "./images/elena_JPG/elena (4).jpg";
import elena5 from "./images/elena_JPG/elena (5).jpg";
import elena6 from "./images/elena_JPG/elena (6).jpg";
import elena7 from "./images/elena_JPG/elena (7).jpg";



import nebulosa1 from "./images/nebulosa/nebulosa (2).jpg";
import nebulosa2 from "./images/nebulosa/nebulosa (3).jpg";
import nebulosa3 from "./images/nebulosa/nebulosa (4).jpg";
import nebulosa4 from "./images/nebulosa/nebulosa (5).jpg";
import nebulosa5 from "./images/nebulosa/nebulosa (6).jpg";
import nebulosa6 from "./images/nebulosa/nebulosa (7).jpg";
import nebulosa7 from "./images/nebulosa/nebulosa (1).jpg";

import rpm1 from "./images/33jpg/33rpm (1).jpg";
import rpm2 from "./images/33jpg/33rpm (2).jpg";
import rpm3 from "./images/33jpg/33rpm (3).jpg";
import rpm4 from "./images/33jpg/33rpm (4).jpg";
import rpm5 from "./images/33jpg/33rpm (5).jpg";
import rpm6 from "./images/33jpg/33rpm (6).jpg";
import rpm7 from "./images/33jpg/33rpm (7).jpg";

import brutal1 from "./images/brutalismo3.0jpg/brutalismo3 (2).jpg";
import brutal2 from "./images/brutalismo3.0jpg/brutalismo3 (3).jpg";
import brutal3 from "./images/brutalismo3.0jpg/brutalismo3 (4).jpg";
import brutal4 from "./images/brutalismo3.0jpg/brutalismo3 (5).jpg";
import brutal5 from "./images/brutalismo3.0jpg/brutalismo3 (6).jpg";
import brutal6 from "./images/brutalismo3.0jpg/brutalismo3 (7).jpg";
import brutal7 from "./images/brutalismo3.0jpg/brutalismo3 (1).jpg";


import palestina from "./images/SUMUD_jpg/palestina (1).jpg"
import palestina2 from "./images/SUMUD_jpg/palestina (2).jpg"
import palestina3 from "./images/SUMUD_jpg/palestina (3).jpg"
import palestina4 from "./images/SUMUD_jpg/palestina (4).jpg"
import palestina5 from "./images/SUMUD_jpg/palestina (5).jpg"
import palestina6 from "./images/SUMUD_jpg/palestina (6).jpg"
import palestina7 from "./images/SUMUD_jpg/palestina (7).jpg"


import mare from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (1).jpg";
import mare2 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (2).jpg";
import mare3 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (3).jpg";
import mare4 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (4).jpg";
import mare5 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (5).jpg";
import mare6 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (6).jpg";
import mare7 from "./images/MARE D’INVERNO (L’EPILOGO)/maredinverno (7).jpg";


import ventiquattrok from "./images/24k/24k (1).jpg";
import ventiquattrok2 from "./images/24k/24k (2).jpg";
import ventiquattrok3 from "./images/24k/24k (3).jpg";
import ventiquattrok4 from "./images/24k/24k (4).jpg";
import ventiquattrok5 from "./images/24k/24k (5).jpg";
import ventiquattrok6 from "./images/24k/24k (6).jpg";
import ventiquattrok7 from "./images/24k/24k (7).jpg";


import mosaico1 from "./images/mosaicoliquido/mosaico (1).jpg"
import mosaico2 from "./images/mosaicoliquido/mosaico (2).jpg"
import mosaico3 from "./images/mosaicoliquido/mosaico (3).jpg"
import mosaico4 from "./images/mosaicoliquido/mosaico (4).jpg"
import mosaico5 from "./images/mosaicoliquido/mosaico (5).jpg"
import mosaico6 from "./images/mosaicoliquido/mosaico (6).jpg"
import mosaico7 from "./images/mosaicoliquido/mosaico (7).jpg"

import donot from "./images/donotconform/donotconform (1).jpg"
import donot2 from "./images/donotconform/donotconform (2).jpg"
import donot3 from "./images/donotconform/donotconform (3).jpg"
import donot4 from "./images/donotconform/donotconform (4).jpg"
import donot5 from "./images/donotconform/donotconform (5).jpg"
import donot6 from "./images/donotconform/donotconform (6).jpg"
import donot7 from "./images/donotconform/donotconform (7).jpg"

import origine1 from "./images/Origine/origine (1).jpg"
import origine2 from "./images/Origine/origine (2).jpg"
import origine3 from "./images/Origine/origine (3).jpg"
import origine4 from "./images/Origine/origine (4).jpg"
import origine5 from "./images/Origine/origine (5).jpg"
import origine6 from "./images/Origine/origine (6).jpg"
import origine7 from "./images/Origine/origine (7).jpg"

import california1 from "./images/californiavibes/california (1).jpg"
import california2 from "./images/californiavibes/california (2).jpg"
import california3 from "./images/californiavibes/california (3).jpg"
import california4 from "./images/californiavibes/california (4).jpg"
import california5 from "./images/californiavibes/california (5).jpg"
import california6 from "./images/californiavibes/california (6).jpg"
import california7 from "./images/californiavibes/california (7).jpg"

import steelandsoul1 from "./images/steelandsoul/steelandsoul (1).jpg"
import steelandsoul2 from "./images/steelandsoul/steelandsoul (2).jpg"
import steelandsoul3 from "./images/steelandsoul/steelandsoul (3).jpg"
import steelandsoul4 from "./images/steelandsoul/steelandsoul (4).jpg"
import steelandsoul5 from "./images/steelandsoul/steelandsoul (5).jpg"
import steelandsoul6 from "./images/steelandsoul/steelandsoul (6).jpg"
import steelandsoul7 from "./images/steelandsoul/steelandsoul (7).jpg"

import monster1 from "./images/monster/monster (1).jpg"
import monster2 from "./images/monster/monster (2).jpg"
import monster3 from "./images/monster/monster (3).jpg"
import monster4 from "./images/monster/monster (4).jpg"
import monster5 from "./images/monster/monster (5).jpg"
import monster6 from "./images/monster/monster (6).jpg"
import monster7 from "./images/monster/monster (7).jpg"

import axismundi1 from "./images/axismundi/axismundi (1).jpg"
import axismundi2 from "./images/axismundi/axismundi (2).jpg"
import axismundi3 from "./images/axismundi/axismundi (3).jpg"
import axismundi4 from "./images/axismundi/axismundi (4).jpg"
import axismundi5 from "./images/axismundi/axismundi (5).jpg"
import axismundi6 from "./images/axismundi/axismundi (6).jpg"
import axismundi7 from "./images/axismundi/axismundi (7).jpg"

import salina1 from "./images/salinajpg/salina (1).jpg"
import salina2 from "./images/salinajpg/salina (2).jpg"
import salina3 from "./images/salinajpg/salina (3).jpg"
import salina4 from "./images/salinajpg/salina (4).jpg"
import salina5 from "./images/salinajpg/salina (5).jpg"
import salina6 from "./images/salinajpg/salina (6).jpg"
import salina7 from "./images/salinajpg/salina (7).jpg"

import fenomeni1 from "./images/fenomeni/fenomeni (2).jpg"
import fenomeni2 from "./images/fenomeni/fenomeni (3).jpg"
import fenomeni3 from "./images/fenomeni/fenomeni (4).jpg"
import fenomeni4 from "./images/fenomeni/fenomeni (5).jpg"
import fenomeni5 from "./images/fenomeni/fenomeni (1).jpg"
import fenomeni6 from "./images/fenomeni/fenomeni (6).jpg"
import fenomeni7 from "./images/fenomeni/fenomeni (7).jpg"


import jazz1 from "./images/jazz/jazz (7).jpg"
import jazz2 from "./images/jazz/jazz (1).jpg"
import jazz3 from "./images/jazz/jazz (2).jpg"
import jazz4 from "./images/jazz/jazz (3).jpg"
import jazz5 from "./images/jazz/jazz (4).jpg"
import jazz6 from "./images/jazz/jazz (5).jpg"
import jazz7 from "./images/jazz/jazz (6).jpg"

import pattern991 from "./images/Pattern99/pattern99 (1).jpg"
import pattern992 from "./images/Pattern99/pattern99 (2).jpg"
import pattern993 from "./images/Pattern99/pattern99 (3).jpg"
import pattern994 from "./images/Pattern99/pattern99 (4).jpg"
import pattern995 from "./images/Pattern99/pattern99 (5).jpg"
import pattern996 from "./images/Pattern99/pattern99 (7).jpg"
import pattern997 from "./images/Pattern99/pattern99 (6).jpg"

import nirvana1 from "./images/nirvana/nirvana1.jpg"
import nirvana2 from "./images/nirvana/nirvana (2).jpg"
import nirvana3 from "./images/nirvana/nirvana (3).jpg"
import nirvana4 from "./images/nirvana/nirvana (4).jpg"
import nirvana5 from "./images/nirvana/nirvana (5).jpg"
import nirvana6 from "./images/nirvana/nirvana (6).jpg"

import patternArgento1 from "./images/pattern175/patternArg (1).jpg";
import patternArgento2 from "./images/pattern175/patternArg (2).jpg";
import patternArgento3 from "./images/pattern175/patternArg (3).jpg";
import patternArgento4 from "./images/pattern175/patternArg (4).jpg";
import patternArgento5 from "./images/pattern175/patternArg (5).jpg";
import patternArgento6 from "./images/pattern175/patternArg (6).jpg";


import topologyArgento1 from "./images/emergedTop2/emArgento (1).jpg";
import topologyArgento2 from "./images/emergedTop2/emArgento (2).jpg";
import topologyArgento3 from "./images/emergedTop2/emArgento (3).jpg";
import topologyArgento4 from "./images/emergedTop2/emArgento (4).jpg";
import topologyArgento5 from "./images/emergedTop2/emArgento (5).jpg";
import topologyArgento6 from "./images/emergedTop2/emArgento (6).jpg";

import emergedTop1 from "./images/emergedTopology/emerged (6).jpg";
import emergedTop2 from "./images/emergedTopology/emerged (1).jpg";
import emergedTop3 from "./images/emergedTopology/emerged (2).jpg";
import emergedTop4 from "./images/emergedTopology/emerged (3).jpg";
import emergedTop5 from "./images/emergedTopology/emerged (4).jpg";
import emergedTop6 from "./images/emergedTopology/emerged (5).jpg";
import emergedTop7 from "./images/emergedTopology/emerged (7).jpg";


import centoottanta1 from "./images/180/180 (1).jpg";
import centoottanta2 from "./images/180/180 (2).jpg";
import centoottanta3 from "./images/180/180 (3).jpg";
import centoottanta4 from "./images/180/180 (4).jpg";
import centoottanta5 from "./images/180/180 (5).jpg";
import centoottanta6 from "./images/180/180 (6).jpg";



export const artworks = [
    {
        id: "sakti",
        src: [occhio1, occhio2, occhio3, occhio4, occhio5, occhio6],
        title: 'L’occhio di Śakti',
        size: '20x20 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto puntinato su tela",
        descrizione: "Qui la geometria si dissolve nella vibrazione spirituale del colore e si sviluppa come un mosaico moderno. " +
            "Al centro, un nucleo rosso vivo richiama l’energia primordiale e generatrice di Śakti — la dea madre dell’induismo, " +
            "principio femminile e dinamico dell’universo." +
            "I cerchi concentrici che si irradiano dal centro non sono solo forme ornamentali: vogliono evocare una certa ciclicità " +
            "e continuità, il respiro dell’universo, la tensione tra ordine e caos.",
    },


    {
        id: "PATTERN99: RADIAL TEXTURE STUDY",
        src: [pattern991, pattern992, pattern993, pattern994, pattern995, pattern996, pattern997],
        title: 'Pattern99: radial texture study',
        size: '90x60 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Dicembre 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico, spray, pasta testurizzata e foglia d’oro",
        descrizione: "Questo piccolo trittico nasce in un pomeriggio estivo, figlio di un momento di creatività. Essi rappresentano i primi esperimenti con l’olio al silicone.\n" +
            "Non vi è stata una particolare ricerca concettuale dietro, ma pura curiosità, in quanto mi stavo approcciando ad una nuova forma e tecnica.\n" +
            "Dunque, questo trittico non sente il bisogno di colpire per l’aspetto emotivo, ma punta al colpo d’occhio e all’armonia che è riuscita a crearsi tra loro, seppur essendo così differenti nelle geometrie e nei colori.\n",
    },



    {
        id: "TH3 D4RK S1D3 0F TH3 M00N",
        src: [pinkfloyd2, pinkfloyd1, pinkfloyd3, pinkfloyd4, pinkfloyd5, pinkfloyd6, pinkfloyd7],
        title: 'TH3 D4RK S1D3 0F TH3 M00N',
        size: '40x50 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Luglio 2025",
        disponibilita: "Venduto",
        tecnica: "pasta testurizzata e effetto puntinato su tela",
        descrizione: "Questa tela nasce come personale omaggio all’impatto culturale e musicale che i Pink Floyd hanno avuto nel panorama mondiale. \"The Dark Side of the Moon\" più che un album, è un simbolo di rottura, di esplorazione interiore e di rivoluzione artistica: una nuova forma di interpretare la musica e la mente.\n" +
            "In questo dipinto, la celebre copertina viene reinterpretata e distorta volutamente, assumendo nuova forma: il fascio di luce non è più generato da una sorgente esterna ma nasce dall’interno stesso della tela, come un'emanazione spontanea e organica, mentre ’arcobaleno si trasforma in un flusso viscerale, personale e intimo.\n" +
            "Il triangolo bianco, geometrico e statico, non domina la composizione ma si nasconde per poi riaffiorare, come se emergesse dal caos per riportare equilibrio.\n" +
            "Lo sfondo nero non è piatto: è stato realizzato tramite una pasta materica e testurizzata, per evocare fedelmente la superficie lunare, omaggiando il simbolismo spaziale e cosmico tanto caro alla band. Lo spazio diventa così terreno fertile per l’introspezione, per la rottura dei limiti, per il viaggio psichedelico.\n" +
            "Questa tela vuole favorire un'intima riflessione sul dualismo tra struttura e caos, tra visibile e invisibile, tra luce e oscurità: un viaggio visivo, proprio come lo è stato quello sonoro creato dai Pink Floyd.\n",
    },



    {
        id:"salina",
        src: [salina1, salina2, salina3, salina4, salina5, salina6, salina7],
        title: 'Fioritura salina',
        size: '55x75 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Dicembre 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto dutch pour su tela",
        descrizione: "La tela nasce dal tentativo di far dialogare due mondi solo apparentemente distanti.\n" +
            "Da un lato il fiore, osservato non nella sua forma esterna, ma nella sua intimità: una visione microscopica fatta di celle, pieni e vuoti, dove la vita si organizza in strutture fluide e imprevedibili.\n" +
            "Dall’altro il mare, evocato non come paesaggio ma come sensazione: una brezza leggera, una corrente che attraversa lo spazio senza appesantire, lasciando tracce di movimento e respiro.\n" +
            "Le forme cellulari diventano così correnti, e le correnti assumono un ritmo organico, quasi vitale. Il confine tra vegetale e marino si dissolve, suggerendo un’origine comune, un linguaggio naturale condiviso.\n",
    },


    {
        id:"donot",
        src: [donot, donot2, donot3, donot4, donot5, donot6, donot7],
        title: 'DO NOT CONFORM',
        size: '75x55 cm',
        supporto: "tela su telaio in legno",
        realizzazione: "Novembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto puntinato su tela",
        descrizione: "Questo quadro afferma un principio essenziale: non devi aderire alla forma “prevista”.\n" +
            "La società tende a ripetere la stessa figura, meccanizzandola, fino a rendere ciò che è simile definitivamente uguale. Chi tenta di uscire da questo ritmo catatonico viene prima punito, poi corretto, per poi infine la cosa peggiore: viene standardizzato. Questa tela però si pone in netto contrasto con ciò, rifiutando quella pressione.\n" +
            "Il colore che cambia nel pattern non è un errore: è la prova che la differenza può restare visibile, anche senza dover chiedere il permesso.\n" +
            "Non conformarsi non significa opporsi a tutti. Significa non cancellarsi per essere accettati. Significa riconoscere la propria identità, rimanendo fedeli a sé stessi, anche quando il contesto spinge in un’unica direzione. Chi sceglie di distinguersi non rompe l’equilibrio: lo ridefinisce.\n" +
            "Questo manifesto difende il diritto a quella scelta. Insegna che una deviazione minima è già un atto politico. Che la coerenza con se stessi vale più della somiglianza agli altri. Che l’uniformità non è un destino: è una resa.\n" +
            "“DO NOT CONFORM” significa proprio questo: proteggi ciò che ti rende unico. Mantieni la tua forma. Resta vivo.\n",
    },
    {
        id:"elena",
        src: [elena1, elena2, elena3, elena4, elena5, elena6, elena7],
        title: 'Ἑλένη',
        size: '78x58 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Settembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, spray e pasta testurizzata su tela",

        descrizione: "Il dipinto nasce da un ricordo personale: in un pomeriggio nuvoloso a Bruxelles all’interno di un museo, dove Elena sedeva in silenzio sulle poltroncine, intenta a contemplare un quadro imponente. In quell’immagine si è depositato il seme dell’opera: sostituire idealmente quel dipinto con questo, trasformando un momento privato in forma espressiva.\n" +
            "La composizione gioca con piani cromatici netti e forme geometriche essenziali: il bronzo richiama l’antichità e la memoria, l’avorio porta luce e apertura, il blu petrolio e il nero introducono profondità e gravità. L’insieme rievoca il linguaggio solido e quasi architettonico delle sale museali, ma filtrato da una sensibilità più intima e personale.\n" +
            "Il titolo “Ἑλένη” rafforza questo dialogo: in greco antico il nome rimanda alla torcia, allo splendore e alla luce che rischiara. È un significato che trova risonanza nei contrasti dell’opera: la luminosità dell’avorio che affiora dalle campiture più scure, il calore del bronzo che vibra accanto al rosso.\n" +
            "Così il quadro diventa un atto di metamorfosi: un ricordo affettivo trasfigurato in spazio universale, un frammento privato che assume la monumentalità dell’icona. “Ἑλένη” vive nella soglia tra dedica intima e monumento privato, come se il gesto personale potesse farsi architettura di memoria e la memoria stessa trasformarsi in luce.\n"

    },

    {
        id:"brutalismo",
        src: [brutal1, brutal2, brutal3, brutal4, brutal5, brutal6, brutal7],
        title: 'Brutalismo 3.0',
        size: '58x78 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Agosto 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto pouring su tela",
        descrizione: "Il quadro trae diretta ispirazione dall’architettura brutalista sovietica, caratterizzata da colori cupi, masse compatte e logiche geometriche rigide. Qui però le forme vengono volutamente sovvertite: ciò che nel cemento è blocco e staticità, qui diventa flusso e materia liquida, come una metamorfosi continua.\n" +
            "Il rosso (tipico sovietico) e il nero dominano la superficie, richiamando la durezza e l’austerità cromatica di questa corrente artistica, ma allo stesso tempo la colata dissolve ogni rigore, aprendo a un immaginario viscerale e instabile. È un brutalismo che non si erge, ma che vuole scorrere tra le “spaccature” createsi.\n" +
            "La tela stessa porta con sé una memoria stratificata: questa è la sua terza vita. Come il brutalismo architettonico ha imposto la propria presenza sulle preesistenze urbane con decisione netta e concisa, così questa tela ha cancellato e inglobato le due opere precedenti, dando origine a una nuova identità.\n" +
            "Ne emerge un lavoro che non celebra superficialmente il brutalismo in sé, ma la sua capacità di riscrittura: un’estetica nata dalla distruzione, rigida e solida nella memoria, ma divenuta con il quadro fluida, emotiva e inquieta.\n",
    },
    {
        id:"MAREDINVERNO",
        src: [mare, mare2, mare3, mare4, mare5, mare6, mare7],
        title: 'Mare d’inverno (l’epilogo)',
        size: '78x58 cm',
        supporto: "acrilico, spray e foglia d’oro tela",
        realizzazione: "Novembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto puntinato su tela",
        descrizione: "Questo quadro nasce da un periodo complesso che ho vissuto, in cui tutto sembrava immobile.\n" +
            "L’edificio sulla destra rappresenta quella fase: una struttura rigida e catatonica, fatta di scelte che non erano più davvero mie. Un’esistenza che continuava per abitudine, più che per convinzione. Tra le finestre spente, una sola brilla d’oro: è l’io; quella parte di me che provava a farsi spazio, anche quando intorno era fermo.\n" +
            "Sulla sinistra è presente il mare d’inverno. Qui le onde non seguono un ordine preciso: si intrecciano e cambiano direzione. Per me sono state l’immagine più onesta di come ci si sente quando qualcosa dentro scalpita, anche se non sai ancora dove ti condurrà.\n" +
            "La piccola barca d’oro è il primo passo verso un altrove. Un gesto minimo, fragile, ma che indica un cambiamento reale. Una decisione che non fa particolare rumore, ma che cambia tutto\n" +
            "In alto ci sono due soli: uno nasce, l’altro muore. Non è un gesto drammatico, ma un passaggio necessario. Una parte va lasciata andare affinché l’altra possa prendere forma.\n" +
            "Questa tela quindi è il racconto di un cambiamento necessario e della scelta – delicata ma radicale – di seguire ciò che ci fa sentire davvero vivi.\n",
    },



    {
        id:"jazz",
        src: [jazz1, jazz2, jazz3, jazz4, jazz5, jazz6, jazz7],
        title: 'Jazz al crepuscolo',
        size: '75x55 cm',
        supporto: "acrilico e effetto puntinato su tela",
        realizzazione: "Novembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto puntinato su tela",
        descrizione: "Questo dipinto nasce da un momento semplice, quasi quotidiano: l’istante in cui il sole si abbassa e il mondo si scalda di un’ultima luce.\n" +
            "L’atmosfera è quella di un lounge bar al tramonto, quando la giornata si ritira e un pianoforte comincia a riempire l’aria con note morbide, quasi sospese.\n" +
            "I colori si inseguono come farebbero le vibrazioni di un brano lento: dal giallo più caldo al viola che annuncia la sera. Tutto è tranquillo, ordinato, ma pieno di quella dolcezza che arriva solo quando la luce cambia davvero.\n" +
            "La tastiera, minimale e silenziosa, non è solo un dettaglio: è il punto in cui la scena diventa uno stato d’animo. Un invito a fermarsi, a respirare, a lasciarsi cullare da un ritmo che non corre, ma accompagna.\n" +
            "È un quadro che non vuole raccontare una storia precisa, ma un momento:\n" +
            "quello in cui il giorno svanisce e la musica diventa il modo più semplice per sentirsi presenti.\n",
    },



    {
        id:"splendere",
        src: [splendere1, splendere2, splendere3, splendere4, splendere5, splendere6, splendere7],
        title: 'Splendere al tramonto',
        size: '50x50 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Agosto 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico, pasta testurizzata e spray su tela",
        descrizione: "Questo quadro nasce da una commissione fattami molto personale, volta ad esprimere su tela quella che è stata la mia carriera calcistica. Per anni ho giocato tra i professionisti, non ero un fenomeno da Serie A, ma venivo considerato un prospetto interessante per il futuro: un percorso che dall’esterno poteva sembrare una promessa luminosa. Eppure, dietro quella luce, non c’era alcuna passione: non ho mai amato il calcio, non l’ho mai seguito, e viverlo dall’interno significava spesso confrontarmi con un senso di vuoto e di amarezza.\n" +
            "I colori caldi del quadro rappresentano il piccolo “successo” che avevo ottenuto, quella parte che brillava e attirava lo sguardo, proprio come il sole al tramonto. Al contrario, i blu intensi e materici raccontano il peso nascosto, la fatica e i momenti più difficili che hanno segnato quella breve carriera. Tra questi poli opposti si muove la banda bianca (a forma di S, come il nome della persona che mi ha commissionato il quadro): fluida, in continua trasformazione, a sottolineare come queste esperienze non fossero mai separate, ma coesistessero nel medesimo momento.\n" +
            "“Splendere al tramonto” vuole restituire questa fragile e intima ambivalenza: l’intensità di un bagliore che appare precoce e forte, ma che al tempo stesso, porta con sé la consapevolezza di quanto possa consumare rapidamente chi non lo sente davvero suo.\n",
    },
    {
        id:"alba",
        src: [alba1, alba2, alba3, alba4, alba5, alba6, alba7],
        title: 'Alba Lisergica',
        size: '50x40 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto pouring su tela",


        descrizione: "Una cassa dritta che martella da ore. Corpi che non si distinguono più, fusi in un’unica massa che pulsa sotto le luci stroboscopiche e la polvere battuta. “Alba Lisergica” nasce lì, nel cuore di un rave che si rifiuta di morire con la notte.\n" +
            "La techno continua a suonare, implacabile, mentre il confine tra realtà e allucinazione si dissolve. L’aria è pesante di sudore, fumo e sogni chimici. \n" +
            "È l’ultimo atto di un rituale underground: una festa senza tempo, dove le sostanze amplificano i sensi e dissolvono i confini individuali.\n" +
            "Un’apparizione quasi onirica – è il sole che sorge – frantumando la notte e svelando il delirio: volti stravolti, occhi lucidi, mani che si cercano senza parlare.\n" +
            "Il quadro è il simbolo di un momento irripetibile: la fusione tra il battito della techno, la sostanza nel sangue e la luce che arriva, lenta, a ricordarti che sei ancora vivo. O forse no.\n",
    },
    {
        id:"granada",
        src: [granada2, granada1, granada3, granada4, granada5, granada6, granada7],
        title: 'I vicoli di una vecchia Granada',
        size: '78x58 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico e effetto pouring su tela",
        descrizione: "Ispirato alla canzone “Ratón” del Diplomatico e il Collettivo Ninco Nanco, il quadro nasce dal desiderio di reinterpretare l’immagine dei vicoli di una vecchia Granada. Nella realtà, quei vicoli sono stretti, bui, segnati dal tempo; ma qui si trasformano in una mappa viva e luminosa, un organismo pulsante in cui ogni frammento contribuisce alla luce comune.\n" +
            "Ogni segno dorato rappresenta una persona: un corpo che danza, respira, vive. Insieme formano i percorsi della città, le sue connessioni invisibili. Nessun vicolo prevale sull’altro, così come nessun individuo brilla da solo: è solo attraverso l’armonia collettiva che la città prende vita, che la notte si accende.\n" +
            "Le linee che attraversano la tela non dividono, ma uniscono. Sono vene di luce che scorrono su un fondo granata profondo — la memoria della terra, del sangue, della storia — e lo trasformano in energia. La tela è dunque un invito alla coralità, alla danza condivisa, alla consapevolezza che la bellezza risiede nell’insieme, nel movimento comune che genera splendore.\n",
    },
    {
        id:"mareaRosa",
        src: [rosa1, rosa2, rosa3, rosa4, rosa5, rosa6],
        title: 'Marea rosa',
        size: '24x18',
        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Venduto",
        tecnica: "Acrilico e effetto pouring su tela",

        descrizione: "Ispirata ai paesaggi eterei delle saline rosa, questa composizione cattura il movimento fluido delle onde salmastre, sospinte dal vento e cristallizzate nella luce del sale.\n" +
            "Le sfumature di rosa e bianco si intrecciano come spuma liquida sulla superficie dell’acqua, mentre il bordo violaceo vuole richiamare l’orizzonte al tramonto — quel momento in cui cielo, terra e mare si fondono in un’unica immagine.\n" +
            "Realizzata con tecnica fluida su tela, \"Marea rosa\"  invita l’osservatore a perdersi nel ritmo lento e sensoriale di un paesaggio che non ha confini netti, ma solo vibrazioni.",
    },
    {
        id:"SUMUD",
        src: [palestina, palestina2, palestina3, palestina4, palestina5, palestina6, palestina7],
        title: 'SUMUD',
        size: '80x60 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Settembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e pasta testurizzata su tela",


        descrizione: "Questo quadro vuole essere uno strumento di sostegno alla causa palestinese e un atto di resistenza contro Israele e il suo governo. Non è solo un’opera visiva, ma una denuncia politica aperta, che accusa senza compromessi chi, dopo essere stato vittima di un genocidio nella storia, oggi con assoluta ferocia ne sta compiendo un altro contro il popolo palestinese. L’orrore subito non ha insegnato nulla: al contrario, si è trasformato in una macchina di oppressione che schiaccia gli innocenti, perpetuando dolore e distruzione.\n" +
            "I blocchi materici evocano le macerie lasciate dai bombardamenti su Gaza: rovine di una terra martoriata, ma al tempo stesso simbolo di solidità e resistenza. Gaza è spezzata, ma non è sconfitta. Gli schizzi di colore rosso richiamano il sangue delle vittime, soprattutto donne e bambini, massacrati con una ferocia che non può e non deve essere dimenticata.\n" +
            "Lo sfondo bianco, colmo di slogan raccolti nelle piazze e sulle piattaforme digitali, rappresenta il grido di chi continua a opporsi, di chi non accetta il silenzio complice. La bandiera palestinese, destrutturata, simboleggia come Israele abbia sempre tentato di cancellare e sopraffare la Palestina fin dalla sua nascita. Ma nonostante la violenza e la volontà di annientamento, l’identità e l’anima palestinese restano vive, infrante ma indistruttibili.\n" +
            "Questa tela è quindi un atto d’accusa, una condanna senza mezzi termini verso Israele e i crimini che sta compiendo, e al tempo stesso un invito a schierarsi, a non distogliere lo sguardo, a continuare a sostenere la resistenza palestinese fino a quando giustizia non verrà fatta.\n",
    },

    {
        id:"FORME-FLUSSI-FENOMENI",
        src: [fenomeni1, fenomeni2, fenomeni3, fenomeni4, fenomeni5, fenomeni6, fenomeni7],
        title: 'Forme, Flussi, Fenomeni',
        size: '20x20',
        supporto: "Tela su telaio in legno",
        realizzazione: "Agosto 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto pouring su tela",

        descrizione: "Facendo questa commissione mi sono posto come obiettivo l’esplorazione della superficie della tela come campo di interferenze concentriche, costruite attraverso una pasta materica modellata in sequenze radiali.\n" +
            "La struttura del rilievo genera una trama di micro-rotazioni che varia a seconda dell’incidenza della luce, rendendo la superficie dinamica e mai identica a sé stessa.\n" +
            "L’applicazione di 99 foglie d’oro funge da elemento misurabile e deliberato: non un simbolo, ma un parametro tecnico che definisce la densità e la continuità della finitura. \n" +
            "La scelta del bordo nero crea un margine netto, che isola il campo testurizzato e lo presenta come un oggetto di osservazione.\n" +
            "Il quadro non nasce da un intento narrativo, ma da una ricerca formale: studiare a ripetizione, la variazione e il comportamento della luce su una superficie radiale.\n" +
            "In questo senso, il lavoro si colloca come una “analisi visiva” più che come un’immagine, con una presenza forte ma priva di sovrastrutture simboliche.\n",
    },



    {
        id:"nevermind-the-bollocks",
        src: [nevermind1, nevermind2, nevermind3, nevermind4, nevermind5, nevermind6, nevermind7],
        title: 'NEVER MIND THE BOLLOCKS (OMAGGIO)',
        size: '50x70 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Luglio 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico e effetto pouring su tela",


        descrizione: "Un chiaro omaggio ai Sex Pistols e all’onda culturale che hanno scatenato nell’Inghilterra degli anni ’70. Questa tela nasce dall’urgenza di rappresentare lo spirito punk nella sua forma più vera: grezza, iconoclasta, instabile.\n" +
            "Il background, realizzato in fluid art con tonalità oscure e acide, richiama il caos urbano e la psichedelia sporca dei sobborghi inglesi. Su questo sfondo agitato emergono le parole \"Never Mind the Bollocks\", riprese direttamente dalla copertina dell’album, ma rielaborate in chiave contemporanea — con colori contaminati, bordi imperfetti e stratificazioni che evocano manifesti strappati, abiti con borchie e rabbia giovanile.\n" +
            "Questo dipinto non vuole essere superficiale e fine a sé stesso, ma vuole rappresentare un manifesto di rottura e identità: un richiamo alla ribellione visiva e sonora che ha riscritto le regole dell’arte, della musica e del costume.\n" +
            "Un tributo alla nobile sporcizia della cultura punk, al diritto di urlare, disobbedire e reinventare un mondo in cui non ci si riconosce.\n",
    },
    {
        id:"ETERE",
        src: [etere1, etere2, etere3, etere4, etere5, etere6, etere7],
        title: 'ETERE',
        size: '50x50 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Maggio 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico su tela",
        descrizione: "La tela rappresenta i 4 elementi; ovvero la terra, il fuoco, l’acqua e l’aria. Essi non si mescolano tra loro, ma coesistono in tensione costante, divisi da linee bianche marcate. \n" +
            "I filosofi dell’antichità credevano che l’etere (il quinto elemento) fosse la sostanza che permeasse l’intero universo; nella tela non è visibile, bensì presupposto: è lo spazio tra le forme, il vuoto che tiene tutto insieme.\n",
    },
    {
        id:"PIANO-QUINQUENNALE",
        src: [pianoQuin1, pianoQuin2, pianoQuin3, pianoQuin4, pianoQuin5, pianoQuin6, pianoQuin7],
        title: 'Piano Quinquennale',
        size: '78x58 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico e pasta testurizzata su tela",

        descrizione: "Piano Quinquennale è una tela concettuale che riflette sul controllo sistemico e la pianificazione forzata dell’economia e della società durante l’epoca sovietica. Il titolo fa riferimento diretto ai cicli di pianificazione economica imposti dall’Unione Sovietica, simbolo di un’organizzazione rigida e centralizzata, spesso disumanizzante. La composizione è scandita da suddivisioni geometriche nette, che evocano compartimenti stagni, settori produttivi o territori suddivisi secondo logiche burocratiche. Al loro interno, texture concentriche circolari suggeriscono movimento ciclico, ripetizione, produzione seriale — ma anche un senso di “spirale ideologica”. Il colore predominante è un rosso scuro bruciato, che richiama direttamente il colore della propaganda e del potere sovietico. L’interazione tra ordine e caos, struttura e ripetizione, invita a riflettere su come i grandi progetti politici si traducono, spesso, in pressioni invisibili sulla vita individuale."

    },
    {
        id:"ABISSO-BLU",
        src: [abisso1, abisso2, abisso3, abisso4, abisso5, abisso6, abisso7],
        title: 'Abisso blu',
        size: '30x24 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Maggio 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto pouring su tela",


        descrizione: "“Abisso blu” è un’opera che vuole richiamare e porre l’accento sui fondali marini, quei luoghi silenziosi, profondi e spesso inesplorati dall’uomo, dove luce e oscurità convivono in sinergia.\n" +
            "Attraverso varie sfumature di blu, la tela punta a raccontare la bellezza nascosta che si cela oltre la superficie: uno spazio visivo dove perdersi, proprio come nel mare.\n" +
            "Il dipinto è un invito concreto a guardare oltre, dove il reale e il tangibile si dissolvono, lasciando spazio all’immaginazione.\n",
    },
    {
        id:"33-RPM",
        src: [rpm1, rpm2, rpm3, rpm4, rpm5, rpm6, rpm7],
        title: '33 RPM',
        size: '50x20 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Settembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, spray e pasta testurizzata su tela",

        descrizione: "La tela trae ispirazione e vuole direttamente evocare i vinili: icona di un’epoca in cui la musica non era soltanto suono, ma oggetto, gesto, rituale. I solchi concentrici incisi nei dischi diventavano tracce di memoria e movimento, capaci di custodire e restituire emozioni.\n" +
            "Nel corso del tempo, con l’avvento della musica digitale il vinile è stato accantonato, relegato a simbolo del passato e del disuso. Eppure, come dimostrano i suoi cerchi concentrici, tutto torna. Ciò che sembrava destinato all’oblio ha saputo rinascere, riaffermando in modo deciso il proprio spazio e conferendo un nuovo valore proprio nell’epoca dominata dall’immateriale.\n" +
            "Questo quadro, con le sue forme essenziali e ripetitive, diventa metafora di questo ciclo eterno: ciò che appartiene al passato non va dimenticato, ma riscoperto e riletto alla luce del presente.\n" +
            "Non tutto ciò che è antico o superato merita di essere abbandonato: al contrario, molte volte ciò che abbiamo alle spalle è ciò che ci permette di riconnetterci con il senso più autentico della bellezza, del ritmo e della vita stessa.\n"

    },
    {
        id:"RIO",
        src: [rio1, rio2, rio3, rio4, rio5, rio6, rio7],
        title: 'Rio Esperanza',
        size: '78x58 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Giugno 2025",
        disponibilita: "Venduto",
        tecnica: " acrilico e effetto pouring su tela",

        descrizione: "La tela nasce dal bisogno di immaginare un luogo lontano e vivo, che scorre libero, nonostante tutto. Ispirato ai fiumi dell’America Latina – simboli di forza e rinascita – questo dipinto rappresenta un flusso che scorre, sia dentro che fuori, luminoso. \n" +
            "In una terra dove spesso convivono meraviglie e difficoltà, il fiume è vita, è resistenza, è speranza che continua ad agitarsi anche quando tutto sembra fermo.\n" +
            "Il quadro è dedicato a chi, nonostante le avversità, continua a sognare e sperare; invita ad un panta rei costante, a lasciarsi cullare dal fiume e non esserne solo più preda.\n",
    },
  
    {
        id:"nebulosa",
        src: [nebulosa1, nebulosa2, nebulosa3, nebulosa4, nebulosa5, nebulosa6, nebulosa7],
        title: 'NGC 4972 – Nebulosa Kaelis',
        size: '',

        supporto: "Tela su telaio in legno",
        realizzazione: "Agosto 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico e effetto pouring su tela",


        descrizione: "\"Quest’opera nasce dal desiderio di creare e trasformare a modo mio una galassia lontana, interpretandone l’essenza senza seguire schemi canonici. Le sfumature blu, viola e verdi evocano la materia cosmica in trasformazione, mentre le linee nere – costellate di stelle – attraversano e spezzano l’armonia del fondo, come rotte interstellari che interrompono il silenzio dello spazio.\n" +
            "        Triste realtà, la “Nebulosa Kaelis” non esiste: è frutto della mia immaginazione. Proprio come molte delle galassie che conosciamo solo attraverso raggi X, radiosegnali e immagini rielaborate artificialmente, anche questa nebulosa prende forma da una libertà interpretativa. I colori e le fattezze sono invenzione, ma non per questo meno reali: ciò che non vediamo può comunque esistere, e possiamo attribuirgli sembianze attraverso la nostra sensibilità.\n" +
            "    Questo lavoro vuole così sottolineare una realtà bicefala: l’universo come territorio di mistero e, al tempo stesso, di creazione. Anche ciò che rimane invisibile può assumere una forma concreta, se abbiamo il coraggio di immaginarla.\n" +
            "\"",
    },
    {
        id:"ctrl",
        src: [ctrl1, ctrl7, ctrl2, ctrl3, ctrl4, ctrl5, ctrl6],
        title: 'CTRL+ALT+?',
        size: '29x24 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Aprile 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico su tela",


        descrizione: "In questo trittico un segnale attraversa tre dimensioni del colore, rompendo l’armonia solo per crearne una nuova.\n" +
            "Nel verde tutto ha origine: è la parte organica e vitale da cui nasce ogni impulso.\n" +
            "Nel rosso l’energia esplode e si espande, pulsante e disordinata, come un cuore che batte al ritmo dell’interferenza.\n" +
            "Nel blu arriva il raffreddamento, la fase finale del viaggio: la forma che si dissolve in quiete.\n" +
            "La linea bianco-nera che attraversa i tre quadri è un glitch vitale, un disturbo che diventa connessione.\n" +
            "Non separa, ma fonde; non distrugge, ma traduce.\n" +
            "È la traccia di un passaggio, la scia di un riavvio, come se l’immagine stessa cercasse di riconfigurarsi dopo un errore.\n" +
            "Questo trittico si pone come un viaggio nella percezione instabile, un tentativo di sincronizzarsi con il caos. Nel disturbo, il colore trova la sua voce; nella frattura, nasce l’unità.\n",
    },
    {
        id:"altrove",
        src: [altrove1, altrove3, altrove4, altrove5, altrove6, altrove7, altrove8, altrove2, altrove10,altrove9],
        title: 'Altrove',
        size: '20x20 cm',

        supporto: "Tela su telaio in legno",
        realizzazione: "Maggio 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico su tela",


        descrizione: "La realizzazione di questi quadri mi ha " +
            "trasportato e fatto sentire bene, come se mi avessero trasportato " +
            "in uno spazio più calmo, lontano dal frastuono della routine ordinaria " +
            "(rappresentata dalle colate bianche e nere).",
    },
    {
        id:"ORIGINE",
        src: [origine1, origine2, origine3,origine4, origine5, origine6, origine7],
        title: 'Origine',
        size: '40x30 cm',
        supporto: "tela su telaio in legno",
        realizzazione: "Luglio 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, effetto pouring e pasta testurizzata su tela",
        descrizione: "Il quadro rappresenta un viaggio alle radici della creazione, un ritorno simbolico al momento in cui tutto ha avuto inizio. La superficie materica, densa e stratificata, restituisce l’idea di un nucleo primordiale che pulsa e vibra, custode silenzioso di un’energia vitale ancora informe.\n" +
            "Le tonalità di rosa, fucsia e viola si fondono e si scontrano, generando un paesaggio che non appartiene né alla terra né al cielo, ma a una dimensione interiore e cosmica allo stesso tempo. È la visione di una materia in divenire, incandescente e viva, che si prepara a dare origine a ciò che esiste.\n" +
            "“Origine” è quindi il racconto visivo di una nascita universale: dal caos alla forma, dall’invisibile al tangibile, dal nulla alla possibilità. Un invito a riflettere sulle forze che ci precedono, che ci hanno generato e che continuano a muovere l’esistenza nel suo eterno fluire.\n",
    },
    {
        id:"california",
        src: [california1, california2, california3, california4, california5, california6, california7],
        title: 'C4L1F0RN14 V1B3S',
        size: '40x30 cm',
        supporto: "acrilico, spray e foglia d’oro tela",
        realizzazione: "Settembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "Acrilico, spray e effetto pouring su tela",
        descrizione: "Questo quadro nasce dalla volontà di reinterpretare in chiave fluid art l’iconica copertina di Californication, album simbolo dei Red Hot Chili Peppers. Attraverso forme geometriche nette e flussi cromatici contrastanti, la tela vuole mettere in dialogo due dimensioni: da un lato la leggerezza e la luminosità delle vibes californiane, con il richiamo alle calde giornate in spiaggia, ai surfisti che danzano sulle onde oceaniche e a quell’estate infinita fatta di mille colori; dall’altro, il senso di disillusione che accompagna chi insegue un sogno spesso irraggiungibile, quello di una California ideale che per molti si rivela un puro miraggio, come un’oasi nel deserto.\n" +
            "Il rosso fluido e incandescente della piscina diventa metafora della passione e della tensione interiore, mentre l’azzurro stellato evoca l’immensità del cielo e la libertà che ispira la West Coast. La linea d’orizzonte fatta di cespugli, segnata dal verde scuro, rappresenta il confine sottile tra desiderio e realtà.\n" +
            "A livello globale, quest’album ha lasciato un’impronta indelebile nella cultura musicale e popolare: un disco che ha saputo raccontare appieno le contraddizioni della società californiana, oscillando tra energia, introspezione e critica del sogno americano. \n",
    },

    {
        id:"steelandsoul",
        src: [steelandsoul1, steelandsoul2, steelandsoul3, steelandsoul4, steelandsoul5, steelandsoul6, steelandsoul7],
        title: 'Steel and Soul',
        size: '58x78 cm',
        supporto: "acrilico, spray e foglia d’oro tela",
        realizzazione: "Ottobre 2025",
        disponibilita: "Venduto",
        tecnica: "Acrilico e spray su tela",
        descrizione: "Questo quadro trova genesi dal contrasto tra ciò che è freddo e ciò che brucia.\n" +
            "È una storia comune fatta di metallo, olio e asfalto, ma anche di silenzi, scelte e libertà.\n" +
            "Rappresenta quella parte di vita che non si lucida mai, che resta sporca di esperienze, di errori, di tutto ciò che è vero.\n" +
            "Ogni segno sul quadro è una traccia di viaggio: una cicatrice, una goccia, un’imperfezione. L’arancio – tipico Harley – richiama il calore della strada, il nero il peso del ferro, il bianco gli spazi che restano ancora inesplorati.\n" +
            "Non è una tela “pulita”, perché non lo è neanche la libertà. È grezza, vissuta, piena di rumore e di respiro.\n" +
            "“Steel and Soul” racconta proprio questo: la forza di restare fedeli a se stessi, anche quando la strada ti consuma — perché in fondo, è lì che l’anima trova davvero la sua forma.\n",
    },
    {
        id:"NATURA-VIVA",
        src: [naturaViva1, naturaViva2, naturaViva3, naturaViva4, naturaViva6, naturaViva7, naturaViva5],
        title: 'Natura viva',
        size: '29x24',

        supporto: "Tela su telaio in legno",
        realizzazione: "Luglio 2025",
        disponibilita: "Acquistabile",
        tecnica: "pasta testurizzata e effetto pouring su tela",


        descrizione: "Nella tela volevo rendere omaggio alla forza pulsante della natura, catturandone l’essenza attraverso materia, luce e colore. La superficie della tela prende vita grazie a una lavorazione testurizzata, che dona tridimensionalità e movimento, evocando la complessità del mondo naturale: la corteccia degli alberi, la roccia erosa dal tempo, le foglie che si intrecciano.\n" +
            "I toni del verde, miscelati con la tecnica del pouring, fluiscono liberamente sulla tela come vene di linfa, simboleggiando la vitalità silenziosa ma incessante degli ecosistemi. A illuminare la composizione, piccoli tocchi dorati emergono come riflessi di luce nella penombra del sottobosco — un richiamo diretto alle lucciole, agli insetti e a tutti quei dettagli minuscoli ma fondamentali che popolano e animano la natura.\n",
    },

    {
        id:"24K",
        src: [ventiquattrok, ventiquattrok2, ventiquattrok3, ventiquattrok4, ventiquattrok5, ventiquattrok6, ventiquattrok7],
        title: '24K',
        size: '30x24 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Settembre 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, spray e pasta testurizzata su tela",
        descrizione: "Quest’opera prende vita da una tela apparentemente compromessa, segnata da difetti che la rendevano perfettamente candidata al cestino. È proprio da quella condizione di rifiuto che è nato il desiderio di trasformazione: invece di abbandonarla, ho scelto di darle una seconda possibilità, correggendola e arricchendola con un pattern concentrico che si espande sulla superficie in una trama regolare e luminosa.\n" +
            "Il colore oro, con la sua forza simbolica, non è stato scelto a caso: rappresenta la rinascita e la preziosità che può emergere anche da ciò che inizialmente appare fragile, imperfetto o non adatto. “24K” diventa così una memoria visiva di resilienza e di riscatto. L’opera vuole sottolineare come nessuno sia “sbagliato” a priori, ma che ciascuno di noi possa splendere quando incontra il contesto giusto in cui esprimersi e la cornice capace di esaltarne il valore.\n" +
            "Quindi, anche dalle situazioni più scomode o dalle esperienze che ci mettono più alla prova può nascere qualcosa di inaspettatamente bello e potente. È il luogo, il tempo e la veste in cui veniamo accolti a permettere alla nostra luce interiore di manifestarsi.\n",
    },


    {
        id:"BABELE VERDE",
        src: [babele1, babele2, babele3, babele4, babele5, babele6, babele7],
        title: 'Babele verde',
        size: '78x58 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Maggio 2025",
        disponibilita: "Venduto",
        tecnica: "Acrilico e pasta testurizzata su tela",
        descrizione: "Con “Babele verde” ho cercato di rappresentare la giungla, un organismo e un luogo vivo dove tutti i suoi componenti parlano la stessa lingua: quella del caos. Il fondo dell’opera, " +
            "ricco di stratificazioni cromatiche e movimento, vuole rappresentare l’energia vitale del mondo naturale e il suo linguaggio misterioso. A interrompere questo caos armonico vi sono tre forme " +
            "geometriche bianche e materiche, come barriere (questi elementi rappresentano l’intervento dell’uomo). Come nel mito della torre di Babele, anche qui l’azione umana nasce dal desiderio di dominio, " +
            "ma finisce per generare disordine, incomunicabilità e frattura con il mondo naturale.",
    },
    {
        id:"AXIS-MUNDI-ARGENTEO",
        src: [axismundi1, axismundi2, axismundi3, axismundi4, axismundi5, axismundi6, axismundi7],
        title: 'Axis Mundi Argenteo',
        size: '30x24 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Agosto 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto pouring su tela",
        descrizione: "Nel centro della tela si erge un albero d’argento, un “Axis Mundi” rivisitato che non si limita a separare, ma vuole collegare due universi distinti. I suoi rami si estendono come nervature vitali, attraversano i confini cromatici e intrecciano ciò che appare inconciliabile: da un lato un mondo vibrante, dinamico e pulsante di energia; dall’altro quello monocromatico, silenzioso e più contemplativo.\n" +
            "Nelle culture antiche l’Axis Mundi era il pilastro che univa cielo e terra, visibile e invisibile, materia e spirito. In questa versione contemporanea, rivestita d’argento metallizzato, l’albero assume un valore nuovo: è simbolo di connessione e armonia, a dimostrazione che anche le differenze più nette, se radicate nello stesso tronco, possono nutrirsi a vicenda e generare bellezza.\n" +
            "“Axis Mundi Argenteo” è dunque una rivisitazione in chiave moderna dell’ albero cosmico; un segno di continuità con i miti universali ma, al tempo stesso, un invito a riconoscere che la diversità è radice di equilibrio.\n",
    },



    {
        id:"MONSTER",
        src: [monster1, monster2, monster3, monster4, monster5, monster6, monster7],
        title: 'Monster Core',
        size: '78x58 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Novembre 2025",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto pouring su tela",
        descrizione: "Questa commissione nasce dalla passione del cliente per la famosa bevanda. È un puro tributo alla caffeina, alla “tamarraggine” e al famoso artiglio verde. Niente concettualismi o chissà quale ricerca dietro, solo la Monster, nella sua forma più diretta ed incisiva possibile. ",
    },
    {
        id:"MOSAICO-LIQUIDO",
        src: [mosaico1, mosaico2, mosaico3, mosaico4, mosaico5, mosaico6, mosaico7],
        title: 'Mosaico liquido',
        size: '60x30 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Ottobre 2025",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, spray e effetto puntinato su tela",
        descrizione: "Con questo quadro ho voluto rappresentare il dialogo tra l’acqua e la materia, tra ciò che scorre e ciò che resta. Nasce dall’immagine delle gocce di pioggia che scivolano su una parete, lasciando dietro di sé un movimento silenzioso, costante, quasi meditativo.\n" +
            "Ogni goccia, trasformata in tessera, diventa parte di un mosaico che cattura la luce e ne riflette il respiro.\n" +
            "Il blu avvolge lo sguardo come un mare calmo: denso, profondo, capace di fermare il tempo e di far emergere una sensazione di quiete interiore.\n" +
            "Questo lavoro vuole essere un invito alla lentezza — a osservare ciò che accade quando l’acqua incontra la superficie e tutto si trasforma in armonia visiva, in silenzio che scivola.\n",
    },


    {
        id: "GEEKED SMILE",
        src: [nirvana1, nirvana2,nirvana3,nirvana4,nirvana5, nirvana6],
        title: 'Geeked smile',
        size: '60x30 cm',
        supporto: "mini telaio in legno",
        realizzazione: "Marzo 2026",
        disponibilita: "Acquistabile",
        tecnica: "acrilico, spray e marker",
        descrizione: `Questo piccolo lavoro nasce come un tributo ai Nirvana, una delle band che più hanno segnato l’immaginario musicale e culturale degli anni ’90.
L’idea non era quella di realizzare un omaggio solenne o nostalgico, ma qualcosa di più spontaneo e leggero, quasi per gioco. L’obiettivo era di catturare quello spirito irriverente, diretto e un po’ sfrontato che ha sempre caratterizzato l’attitudine della band.
La composizione è costruita attraverso ripetizioni e contrasti visivi: una struttura ritmica fatta di moduli e pattern che lentamente costruiscono l’immagine, fino a far emergere il sorriso iconico reinterpretato in chiave più pop e grafica.
Un piccolo esercizio visivo che prova a mettere insieme energia grunge, ritmo visivo e cultura pop.
`,
    },

    
    {
       
        id: "PATTERN 175",
        src: [patternArgento1, patternArgento2, patternArgento2, patternArgento3, patternArgento4, patternArgento5, patternArgento6],
        title: 'Pattern 175: Radial Texture Study',
        size: '90x60 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Aprile 2026",
        disponibilita: "Venduto",
        tecnica: "acrilico, spray, foglia d’argento e pasta testurizzata",
        descrizione: `Il quadro prosegue l’esplorazione della superficie iniziata nel precedente lavoro di qualche mese fa. La tela viene interpretata come campo strutturato di interferenze concentriche, sviluppato attraverso gesti radiali in pasta materica. 
La ripetizione del movimento circolare genera un sistema sì controllato, ma non uniforme, in cui ogni segmento varia leggermente sia per densità che per direzione. Questo produce una superficie capace di reagire alla luce in modo variabile e non prevedibile, restituendo una vibrazione più fredda e metallica rispetto alla sua controparte dorata. 
L’applicazione a mano di 175 foglie d’argento introduce un parametro misurabile, definendo la continuità visiva e il comportamento riflettente dell’opera. 
Il bordo nero funziona come elemento di delimitazione, isolando il campo testurizzato e rafforzandone la presenza come oggetto di osservazione. 
Contestualmente al lavoro gemello precedente, la tela non nasce da un intento narrativo e personale, ma da una ricerca formale: indagare la ripetizione e la variazione attraverso l’interazione tra materiale, luce e struttura radiale. 
`,
    },

    {
       
        id: "EMERGENT TOPOLOGY",
        src: [topologyArgento1, topologyArgento2, topologyArgento3, topologyArgento4, topologyArgento5, topologyArgento6],
        title: 'STF - 01: Emergent Topology',
        size: '60x30 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Aprile 2026",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto puntinato",
        descrizione: `Questo lavoro nasce come una commissione, a partire da un mio precedente dipinto, “I vicoli di una vecchia Granada”. Non rappresenta una ripresa diretta dello stesso, ma una trasposizione: un tentativo simultaneo di trattenere e far emergere una struttura, lasciando però che il processo la trasformi.
Attraverso una ripetizione quasi alienante del gesto e un controllo solo parziale del segno, la superficie si è costruita in modo progressivo, seguendo logiche più vicine alla topologia che alla rappresentazione. Non vi è alcun disegno o bozza preparatoria, solo una crescita: accumulo, deviazione, ritorno.
Da questa dinamica emerge una traccia sottile, quasi involontaria — una mappa. Non geografica né tantomeno reale. Piuttosto una città possibile, instabile, onirica, che prende forma senza mai fissarsi davvero.
Un sistema che si organizza nel momento stesso in cui prende vita.`,
    },

    {
       
        id: "EMERGENT TOPOLOGY2",
        src: [emergedTop1, emergedTop2, emergedTop3, emergedTop4, emergedTop5, emergedTop6, emergedTop7],
        title: 'STF - 02: Emergent Topology',
        size: '60x30 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Aprile 2026",
        disponibilita: "Venduto",
        tecnica: "acrilico e effetto puntinato",
        descrizione: `Secondo lavoro nato all’interno della serie “Structure Field (STF)”, realizzato come controparte del precedente lavoro in oro.
Se nella prima versione la struttura sembrava espandersi in modo organico, fino quasi a respirare di più, qui il segno cambia direzione: tende a chiudersi e comprimersi, generando una rete più fredda e fitta. 
Attraverso la ripetizione quasi alienante del gesto e l’accumulo progressivo della materia, la superficie ha iniziato lentamente a suggerire una traccia urbana involontaria: una cartografia instabile e immaginaria, quasi onirica. 
In questo modo non è nata una città reale, ma il residuo visivo di un movimento continuo da parte di chi la abita.

`,
    },

     {
       
        id: "180",
        src: [centoottanta3, centoottanta1, centoottanta2, centoottanta4, centoottanta5, centoottanta6],
        title: '180°',
        size: '50x50 cm',
        supporto: "Tela su telaio in legno",
        realizzazione: "Febbraio 2026",
        disponibilita: "Acquistabile",
        tecnica: " acrilico, spray e pasta",
        descrizione: `La tela nasce da una semplice domanda: che succede se realizzo un quadro appendibile in ambedue i versi?
        Ruotandolo di 180 gradi, cambia volto. Il colore si sposta, il peso visivo si ribalta e la sensazione percepita risulta differente. Eppure l’opera è sempre la medesima. Non esiste quindi un lato giusto e uno sbagliato: entrambe le direzioni sono valide.
        Il lavoro intende esplorare il concetto di dualismo e sulla possibilità di scelta. Basta un gesto minimo e “banale” – capovolgerlo – per cambiare totalmente prospettiva. Quello che prima sembrava “sopra” diventa “sotto”, ciò che appariva dominante si trasforma.
        La profondità della tela sta nel mettere in discussione l’idea di errore: nonostante si possa esser convinti che solo una direzione sia valida, si può scoprire che non c’è mai una scelta giusta univoca e che quindi, può andare bene anche l’alternativa.
        In “180°” quindi non esiste una versione giusta e una sbagliata: qualsiasi è corretta e va bene così in fondo.`,
    },


];

